import type { StrictEligibility } from "../../types";

export const EMPTY_ELIGIBILITY: StrictEligibility = {
    __typename: "Eligibility",
    ageGroup: "NotAdult",
    cohort: "None",
    userClassification: {
        __typename: "UserClassification",
        persona: "None",
        eduType: "None",
    },
    isCopilotEligible: false,
    isCopilotEnabledRegion: false,
    isOptedOutByAdmin: false,
    featureSet: {
        __typename: "FeatureSetInfo",
        serverFeatures: [],
        uxFeatures: [],
    },
};
